<template>
  <div class="app-container">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-position="left"
      label-width="220px"
      style="width: 80%; margin-left:50px;"
    >
      <el-form-item label="等级名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="等级" prop="grade">
        <el-select
          v-model="form.grade"
          placeholder="请选择"
          style="width: 100%"
          class="filter-item"
          clearable
        >
          <el-option
            v-for="item in 10"
            :key="item"
            :label="item + '级'"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <!--      等级升级条件-->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span
            >等级升级条件<span class="relation_msg"
              >（至少填写一个升级条件）</span
            ></span
          >
        </div>
        <div class="text item">
          <el-form-item label="升级条件的关系" prop="relation">
            <el-radio-group v-model="form.relation" >
              <el-radio
                v-for="item in UPGRADES_CONDITIONS"
                :key="item.key"
                :label="item.key"
                :value="item.key"
                >{{ item.value }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="条件1：累计爆单商品消费金额"
            prop="hotCastAmount"
          >
            <el-input
              v-model="form.hotCastAmount"
              placeholder="请输入"
              style="width: 100%"
              class="filter-item"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="条件2：累计所有商品消费金额"
            prop="allCastAmount"
          >
            <el-input
              v-model="form.allCastAmount"
              placeholder="请输入"
              style="width: 100%"
              class="filter-item"
              clearable
            />
          </el-form-item>
          <el-form-item label="条件3：团队业绩金额" prop="teamAmount">
            <el-input
              v-model="form.teamAmount"
              placeholder="请输入"
              style="width: 100%"
              class="filter-item"
              clearable
            />
          </el-form-item>
          <el-form-item label="条件4：直推下线达到平级人数" prop="sameGrade">
            <el-input
              v-model="form.sameGrade"
              placeholder="请输入"
              style="width: 100%"
              class="filter-item"
              clearable
            />
          </el-form-item>
          <el-form-item label="条件5：实物商品" prop="refId">
            <div>
              <el-input
                v-model="productForm.keyword"
                placeholder="商品名称"
                style="width: 30%"
                clearable
                size="small"
              />
              <el-select
                v-model="productForm.type"
                placeholder="抽奖模式"
                style="width: 120px;margin: 0 10px"
                class="filter-item"
                clearable
                size="small"
              >
                <el-option
                  v-for="item in PRODUCT_TYPE"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
              <el-button
                class="filter-item"
                type="primary"
                icon="el-icon-search"
                @click="handleFilter"
                size="small"
                >搜索</el-button
              >
              <el-table
                ref="multipleTable"
                :data="productTableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                size="mini"
                v-loading="tableLoading"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="id" label="商品编号" width="80">
                </el-table-column>
                <el-table-column prop="mainGraph" label="商品图" width="100">
                  <template slot-scope="scope">
                    <el-image
                      style="width: 50px; height: 50px"
                      :src="scope.row.mainGraph"
                      fit="cover"
                    ></el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称">
                </el-table-column>
              </el-table>
              <div class="pagination-container">
                <el-pagination
                  small
                  :current-page="productForm.page"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="productForm.pageSize"
                  :total="productTableTotal"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </div>
            </div>
          </el-form-item>
        </div>
      </el-card>
      <!--      爆单区权益设置-->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>爆单区权益设置<span class="relation_msg">（必填）</span></span>
        </div>
        <div class="text item">
          <div>
            <div class="item_title">直推</div>
            <!--设置直推-->
            <div v-if="form.hot.zt && form.hot.zt.length !== 0">
              <div
                v-for="(item, index) in form.hot.zt"
                :key="index"
                class="prizeJson_warp"
              >
                <el-select
                  v-model="item.category"
                  placeholder="账户类别"
                  style="width: 20%"
                  class="filter-item"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in accoutCategoryOption"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
                <el-select
                  v-model="item.type"
                  placeholder="账户类型"
                  style="width: 20%"
                  class="filter-item"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in ACCOUNT_TYPE"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
                <el-input
                  v-model="item.rate"
                  placeholder="赠送直推下线消费金额的百分比"
                  style="width: 20%"
                  size="small"
                >
                  <template slot="append">%</template>
                </el-input>
                <el-button
                  @click="deletePrizes('hot', 'zt', index)"
                  size="small"
                  type="danger"
                  round
                  >删除</el-button
                >
              </div>
            </div>
            <el-button
              @click="addPrizes('hot', 'zt')"
              style="width: 100%;"
              size="small"
              >添加配置</el-button
            >
          </div>
          <el-divider></el-divider>
          <div>
            <div class="item_title">间推</div>
            <!--设置间推-->
            <div v-if="form.hot.jt && form.hot.jt.length !== 0">
              <div
                v-for="(item, index) in form.hot.jt"
                :key="index"
                class="prizeJson_warp"
              >
                <el-select
                  v-model="item.category"
                  placeholder="账户类别"
                  style="width: 20%"
                  class="filter-item"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in accoutCategoryOption"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
                <el-select
                  v-model="item.type"
                  placeholder="账户类型"
                  style="width: 20%"
                  class="filter-item"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in ACCOUNT_TYPE"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
                <el-input
                  v-model="item.rate"
                  placeholder="赠送直推下线消费金额的百分比"
                  style="width: 20%"
                  size="small"
                >
                  <template slot="append">%</template>
                </el-input>
                <el-button
                  @click="deletePrizes('hot', 'jt', index)"
                  size="small"
                  type="danger"
                  round
                  >删除</el-button
                >
              </div>
            </div>
            <el-button
              @click="addPrizes('hot', 'jt')"
              style="width: 100%;"
              size="small"
              >添加配置</el-button
            >
          </div>
        </div>
      </el-card>
      <!--      好物区权益设置-->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>好物区权益设置<span class="relation_msg">（必填）</span></span>
        </div>
        <div class="text item">
          <div>
            <div class="item_title">直推</div>
            <!--设置直推-->
            <div v-if="form.good.zt && form.good.zt.length !== 0">
              <div
                v-for="(item, index) in form.good.zt"
                :key="index"
                class="prizeJson_warp"
              >
                <el-select
                  v-model="item.category"
                  placeholder="账户类别"
                  style="width: 20%"
                  class="filter-item"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in accoutCategoryOption"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
                <el-select
                  v-model="item.type"
                  placeholder="账户类型"
                  style="width: 20%"
                  class="filter-item"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in ACCOUNT_TYPE"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
                <el-input
                  v-model="item.rate"
                  placeholder="赠送直推下线消费金额的百分比"
                  style="width: 20%"
                  size="small"
                >
                  <template slot="append">%</template>
                </el-input>
                <el-button
                  @click="deletePrizes('good', 'zt', index)"
                  size="small"
                  type="danger"
                  round
                  >删除</el-button
                >
              </div>
            </div>
            <el-button
              @click="addPrizes('good', 'zt')"
              style="width: 100%;"
              size="small"
              >添加配置</el-button
            >
          </div>
          <el-divider></el-divider>
          <div>
            <div class="item_title">间推</div>
            <!--设置间推-->
            <div v-if="form.good.jt && form.good.jt.length !== 0">
              <div
                v-for="(item, index) in form.good.jt"
                :key="index"
                class="prizeJson_warp"
              >
                <el-select
                  v-model="item.category"
                  placeholder="账户类别"
                  style="width: 20%"
                  class="filter-item"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in accoutCategoryOption"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
                <el-select
                  v-model="item.type"
                  placeholder="账户类型"
                  style="width: 20%"
                  class="filter-item"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in ACCOUNT_TYPE"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
                <el-input
                  v-model="item.rate"
                  placeholder="赠送直推下线消费金额的百分比"
                  style="width: 20%"
                  size="small"
                >
                  <template slot="append">%</template>
                </el-input>
                <el-button
                  @click="deletePrizes('good', 'jt', index)"
                  size="small"
                  type="danger"
                  round
                  >删除</el-button
                >
              </div>
            </div>
            <el-button
              @click="addPrizes('good', 'jt')"
              style="width: 100%;"
              size="small"
              >添加配置</el-button
            >
          </div>
        </div>
      </el-card>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="jumpList">取消</el-button>
      <el-button type="primary" @click="saveAddOrEditData" :loading="btnLoading"
        >确定</el-button
      >
    </div>
  </div>
</template>

<script>
import { UPLOAD_IMG_TYPE, PRODUCT_TYPE, ACCOUNT_TYPE } from "@/utils/enumUtile";
import { updateGrade, getGradeDetail, getCategoryNames } from "@/api/system.js";
import { getGoodsList } from "@/api/product.js";
import { UPGRADES_CONDITIONS } from "@/utils/enumUtile";
import { Message } from "element-ui";
import { toFixedNumFun } from "@/utils";

export default {
  name: "addOrEditGrade",
  computed: {
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    UPGRADES_CONDITIONS() {
      return UPGRADES_CONDITIONS;
    },
    PRODUCT_TYPE() {
      return PRODUCT_TYPE;
    },
    ACCOUNT_TYPE() {
      return ACCOUNT_TYPE;
    }
  },
  components: {},
  data() {
    return {
      rules: {
        grade: [{ required: true, message: "等级不能为空", trigger: "change" }],
        name: [
          { required: true, message: "等级名称不能为空", trigger: "change" }
        ],
        relation: [
          {
            required: true,
            message: "多个升级条件的关系不能为空",
            trigger: "change"
          }
        ]
      },
      form: {
        id: 0,
        grade: null,
        name: null, //
        relation: null,
        qySet: [], //
        good: {
          zt: [],
          jt: []
        },
        hot: {
          zt: [],
          jt: []
        },
        goodsId: null, //
        hotCastAmount: null, //
        allCastAmount: null, //
        teamAmount: null, //
        sameGrade: null //
      },
      btnLoading: false,
      productForm: {
        status: 2,
        keyword: "",
        type: "",
        page: 1,
        pageSize: 10
      },
      productTableData: [],
      productTableTotal: 0, //
      tableLoading: false,
      accoutCategoryOption: [] // 账户类别
    };
  },
  mounted() {
    const id = this.$route.params.id;
    if (id && id !== 0) {
      this.form.id = id;
      this.getById();
    }
    this.getAccoutCategoryOption();
    this.getGoodsList();
  },
  methods: {
    handleFilter() {
      this.productForm.page = 1;
      this.getGoodsList();
    },
    handleSizeChange(val) {
      this.productForm.pageSize = val;
      this.getGoodsList();
    },
    handleCurrentChange(val) {
      this.productForm.page = val;
      this.getGoodsList();
    },
    /**
     * 查询账户类型
     */
    getAccoutCategoryOption() {
      getCategoryNames().then(resp => {
        let data = [];
        if (resp && resp.bizcode === 100) {
          data = resp.data;
        }
        this.accoutCategoryOption = data;
      });
    },
    /**
     * 查询要修改的对象
     */
    getById() {
      const params = {
        id: this.form.id
      };
      getGradeDetail(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          const editObj = resp.data;
          this.form.id = editObj.id;
          this.form.grade = editObj.grade;
          this.form.name = editObj.name;
          this.form.relation = editObj.yqRelation;
          this.form.goodsId = editObj.yqGoodsId;
          this.form.hotCastAmount = editObj.yqHotcastAmount;
          this.form.allCastAmount = editObj.yqAllcastAmount;
          this.form.teamAmount = editObj.yqTeamAmount;
          this.form.sameGrade = editObj.yqSameGrade;
          const currentQySet = editObj.qySet
            ? this.handleQySet(JSON.parse(editObj.qySet), "find")
            : {};
          this.form.qySet = editObj.qySet;
          if (currentQySet && Object.keys(currentQySet).length !== 0) {
            if (currentQySet.hot) {
              this.form.hot = currentQySet.hot || {};
            }
            if (currentQySet.good) {
              this.form.good = currentQySet.good || {};
            }
          } else {
            this.form.hot = {
              zt: [],
              jt: []
            };
            this.form.good = {
              zt: [],
              jt: []
            };
          }
        }
      });
    },
    /**
     * 处理配置数据
     */
    handleQySet(data, type) {
      const currentQySet = data;
      // 爆单区权益设置
      if (currentQySet.hot) {
        if (currentQySet.hot.zt) {
          currentQySet.hot.zt = this.handleQyRate(currentQySet.hot.zt, type);
        } else {
          currentQySet.hot.zt = {};
        }
        if (currentQySet.hot.jt) {
          currentQySet.hot.jt = this.handleQyRate(currentQySet.hot.jt, type);
        } else {
          currentQySet.hot.zt = {};
        }
      } else {
        currentQySet.hot = {
          zt: [],
          jt: []
        };
      }
      // 好物区权益设置
      if (currentQySet.good) {
        if (currentQySet.good.zt) {
          currentQySet.good.zt = this.handleQyRate(currentQySet.good.zt, type);
        } else {
          currentQySet.good.zt = {};
        }
        if (currentQySet.good.jt) {
          currentQySet.good.jt = this.handleQyRate(currentQySet.good.jt, type);
        } else {
          currentQySet.good.zt = {};
        }
      } else {
        currentQySet.good = {
          zt: [],
          jt: []
        };
      }
      return currentQySet;
    },
    /**
     * 处理配置数据
     */
    handleQyRate(data, type) {
      if (!data || data.length === 0) {
        return [];
      }
      const currentData = data;
      currentData.map(item => {
        if (item.rate) {
          if (type === "save") {
            item.rate = toFixedNumFun(item.rate, "save");
          }
          if (type === "find") {
            item.rate = item.rate * 100;
          }
        }
      });
      return currentData;
    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          // 用来判断权益是否填写
          let flag = false;
          if (form.hot && Object.keys(form.hot).length !== 0) {
            if (form.hot.zt.length !== 0) {
              flag = true;
            }
            if (form.hot.jt.length !== 0) {
              flag = true;
            }
          }
          if (form.good && Object.keys(form.good).length !== 0) {
            if (form.good.zt.length !== 0) {
              flag = true;
            }
            if (form.good.jt.length !== 0) {
              flag = true;
            }
          }
          if (!flag) {
            Message({
              message: "请至少配置一项权益",
              type: "error",
              duration: 2 * 1000
            });
            return;
          }
          const params = {
            grade: form.grade,
            name: form.name,
            relation: form.relation,
            goodsId: form.goodsId
          };
          if (form.hotCastAmount) {
            params.hotCastAmount = parseInt(form.hotCastAmount, 10);
          }
          if (form.allCastAmount) {
            params.allCastAmount = parseInt(form.allCastAmount, 10);
          }
          if (form.teamAmount) {
            params.teamAmount = parseInt(form.teamAmount, 10);
          }
          if (form.sameGrade) {
            params.sameGrade = parseInt(form.sameGrade, 10);
          }
          let qySet = {};
          if (form.hot && Object.keys(form.hot).length !== 0) {
            qySet.hot = form.hot;
          }
          if (form.good && Object.keys(form.good).length !== 0) {
            qySet.good = form.good;
          }
          if (qySet && Object.keys(qySet).length !== 0) {
            params.qySet = JSON.stringify(this.handleQySet(qySet, "save"));
          }
          if (form.id && form.id !== 0) {
            params.id = form.id;
          }
          delete form.hot;
          delete form.good;

          this.btnLoading = true;
          updateGrade(params)
            .then(res => {
              if (res && res.bizcode === 100) {
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success",
                  duration: 2000
                });
                setTimeout(() => {
                  this.jumpListFun();
                });
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    /**
     * 返回到列表
     */
    jumpListFun() {
      this.$router.push({ path: "/system/grade" });
    },
    jumpList() {
      this.$confirm("当前编辑的内容未保存，是否立即返回等级列表？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.jumpListFun();
      });
    },
    // 添加配置
    addPrizes(type1, type2) {
      let data = this.form[type1][type2];
      data.push({
        category: null, // 账户类别
        type: null, // 账户类型
        rate: null // 赠送直推下线消费金额的百分比
      });
      this.form[type1][type2] = data;
    },
    // 删除配置
    deletePrizes(type1, type2, index) {
      this.form[type1][type2].splice(index, 1);
    },
    /**
     * 查询商品列表
     */
    getGoodsList() {
      this.tableLoading = true;
      const params = {
        ...this.productForm
      };
      getGoodsList(params)
        .then(resp => {
          this.productTableData = resp.data.entitys;
          this.productTableTotal = resp.data.totalCount;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    /**
     * 选择关联商品
     * @param item
     */
    handleSelectionChange(item) {
      this.form.goodsId = item[0].id;
    }
  }
};
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: center;
}
.prizeJson_warp {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.relation_msg {
  color: red;
  font-weight: 400;
  font-size: 12px;
}
.box-card {
  margin-bottom: 10px;
  border: 1px solid #11b95c;
  .item_title {
    color: #000000;
    margin-bottom: 10px;
  }
}
::v-deep .el-card__header {
  padding: 0px;
}
.clearfix {
  padding: 10px 20px;
  background-color: #11b95c;
  color: #eeeeee;
  font-weight: bold;
}
</style>
